import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/* PrimeNG Modules */
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePickerModule } from 'primeng/datepicker';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { PopoverModule } from 'primeng/popover';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { ChipModule } from 'primeng/chip';
import { StepperModule } from 'primeng/stepper';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

/* PrimeNG Services */
import { ConfirmationService, MessageService } from 'primeng/api';

@NgModule({
  exports: [
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    CardModule,
    TableModule,
    DialogModule,
    ToastModule,
    ToolbarModule,
    CheckboxModule,
    RadioButtonModule,
    DatePickerModule,
    ProgressBarModule,
    SelectModule,
    TabsModule,
    ToggleSwitchModule,
    BadgeModule,
    TableModule,
    PopoverModule,
    TooltipModule,
    TagModule,
    DividerModule,
    ChipModule,
    StepperModule,
    MultiSelectModule,
    ConfirmDialogModule,
    PopoverModule,
  ],
  providers: [ConfirmationService, MessageService],
})
export class PrimeNgModule {}
